<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>All Sales</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title size="large">All Sales</ion-title>
                </ion-toolbar>
            </ion-header>

            <div id="container">
                <ion-segment :value="segment" @ionChange="segmentChanged($event)" class="ion-text-center"
                    scrollable="true" style="margin:auto;" id="ionSegmentScroll">
                    <ion-segment-button value="PendingInstallation" class="ion-text-center" style="margin:auto;">
                        <ion-label>Pending Installation</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="PendingSale" class="ion-text-center" style="margin:auto;">
                        <ion-label>Pending Sale</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="AllSale" class="ion-text-center" style="margin:auto;">
                        <ion-label>All Ships</ion-label>
                    </ion-segment-button>
                </ion-segment>
                <div v-if="pendingInstallation">
                    <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="pendingInstallations"
                        :lazy="true" :paginator="true" :rows="pendingInsPerPage" :totalRecords="pendingInsTotal"
                        @page="pendingInsSaleOnPage($event)"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                        <template #loading>
                            Loading data, please wait...
                        </template>
                        <template #empty>
                            No records found
                        </template>
                        <!-- <Column field="serial" header="#"></Column> -->
                        <Column field="id" header="ID"></Column>
                        <Column header="Product">
                            <template #body="{data}">
                                <div>{{ data.product ? data.product.name : 'GPS Tracking' }}</div>
                                <div v-if="data.items && data.items.length" class="sale-lines">
                                    <div v-for="item in data.items" :key="item.id">{{ item.name }}: {{ item.quantity }} × {{ item.unit_price }}<span v-if="item.charge_type === 'recurring'"> × {{ item.periods }}</span></div>
                                    <b v-if="data.total_value">Total: {{ data.total_value }}</b>
                                </div>
                            </template>
                        </Column>
                        <Column field="company_name" header="Company"></Column>
                        <Column field="company_address" header="Company Address"></Column>
                        <Column field="client_name" header="Client"></Column>
                        <Column field="client_phone" header="Client Phone"></Column>
                        <Column field="power_source_type" header="Power Sourch Type"></Column>
                        <Column field="sale_type" header="Sales Type"></Column>
                        <Column field="salesBy" header="Sales By">
                            <template #body="{data}">
                                <div v-html="data.sales_by.name"></div>
                            </template>
                        </Column>
                        <Column field="number_of_ships" header="Number of Ships">
                            <template #body="{data}">
                                <div>
                                    {{data.installation_requistions.length}} / {{data.number_of_ships}}
                                </div>
                            </template>
                        </Column>
                        <Column field="installation_charge_per_ship" header="Installation Charge / Ship"></Column>
                        <Column field="solar_panel_price_per_ship" header="Solar Panel Price / Ship"></Column>
                        <Column field="monthly_subscription_fee_per_ship" header="Monthly Subs. Fee / Ship"></Column>
                        <Column field="device_price_per_ship" header="Device Price / Ship"></Column>
                        <Column field="warantry_days" header="Warantry Days"></Column>
                        <Column field="source_of_sale" header="Source of Sale"></Column>
                        <Column field="status" v-if="pendingInstallations.status!=null" header="Status"></Column>
                        <Column field="" header="" v-if="jsonDecode(pendingInstallations.approval_status)">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" >
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">1st Approval
                                                ({{jsonDecode(data.approval_status)['first_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['first_approval']}}</ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        <Column field="" header="" v-if="jsonDecode(pendingInstallations.approval_status)">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" >
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">Final Approval
                                                ({{jsonDecode(data.approval_status)['final_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['final_approval']}}</ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        <Column field="number_of_ships" header="Action">
                            <template #body="{data}">
                                <div v-if="['Pending','Cancel'].includes(data.status) == false">
                                    <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                        @click="createRequisiton(data.id,data.has_companies)" size="small">Create
                                        Requisition</ion-button>
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-if="pendingSale">
                    <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="pendingSales"
                        :lazy="true" :paginator="true" :rows="pendingPerPage" :totalRecords="pendingTotal"
                        @page="pendingSaleOnPage($event)"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                        <template #loading>
                            Loading data, please wait...
                        </template>
                        <template #empty>
                            No records found
                        </template>
                        <!-- <Column field="serial" header="#"></Column> -->
                        <Column field="id" header="ID"></Column>
                        <Column header="Product">
                            <template #body="{data}">
                                <div>{{ data.product ? data.product.name : 'GPS Tracking' }}</div>
                                <div v-if="data.items && data.items.length" class="sale-lines">
                                    <div v-for="item in data.items" :key="item.id">{{ item.name }}: {{ item.quantity }} × {{ item.unit_price }}<span v-if="item.charge_type === 'recurring'"> × {{ item.periods }}</span></div>
                                    <b v-if="data.total_value">Total: {{ data.total_value }}</b>
                                </div>
                            </template>
                        </Column>
                        <Column field="company_name" header="Company"></Column>
                        <Column field="company_address" header="Company Address"></Column>
                        <Column field="client_name" header="Client"></Column>
                        <Column field="client_phone" header="Client Phone"></Column>
                        <Column field="power_source_type" header="Power Sourch Type"></Column>
                        <Column field="sale_type" header="Sales Type"></Column>
                        <Column field="salesBy" header="Sales By">
                            <template #body="{data}">
                                <div v-html="data.sales_by.name"></div>
                            </template>
                        </Column>
                        <Column field="number_of_ships" header="Number of Ships">
                            <template #body="{data}">
                                <div>
                                    {{data.installation_requistions.length}} / {{data.number_of_ships}}
                                </div>
                            </template>
                        </Column>
                        <Column field="installation_charge_per_ship" header="Installation Charge / Ship"></Column>
                        <Column field="solar_panel_price_per_ship" header="Solar Panel Price / Ship"></Column>
                        <Column field="monthly_subscription_fee_per_ship" header="Monthly Subs. Fee / Ship"></Column>
                        <Column field="device_price_per_ship" header="Device Price / Ship"></Column>
                        <Column field="warantry_days" header="Warantry Days"></Column>
                        <Column field="source_of_sale" header="Source of Sale"></Column>
                        <Column field="status" header="Status"></Column>
                        <Column field="" header="">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" v-if="jsonDecode(data.approval_status)">
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">1st Approval
                                                ({{jsonDecode(data.approval_status)['first_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['first_approval']}}</ion-col>
                                    </ion-row>
                                    <ion-row v-if="data.status == 'Pending' && jsonDecode(data.approval_status)['first_approval'] == 'No' && user!=null && user.id == 32">
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Approve')" size="small" color="success" fill="outline">Approve</ion-button>
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Cancel')" size="small" color="danger" fill="outline">Cancel</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        <Column field="" header="">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" v-if="jsonDecode(data.approval_status)">
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">Final Approval
                                                ({{jsonDecode(data.approval_status)['final_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['final_approval']}}</ion-col>
                                    </ion-row>
                                    <ion-row v-if="data.status == 'Pending' && jsonDecode(data.approval_status)['final_approval'] == 'No' && user!=null && user.id == 3">
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Approve',jsonDecode(data.approval_status)['first_approval']=='No' ? true:false)" size="small" color="success" fill="outline">Approve</ion-button>
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Cancel')" size="small" color="danger" fill="outline">Cancel</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        
                    </DataTable>
                </div>

                <div v-if="allSale">
                    <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="sales" :lazy="true"
                        :paginator="true" :rows="perPage" :totalRecords="total" @page="onPage($event)"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                        <template #loading>
                            Loading data, please wait...
                        </template>
                        <template #empty>
                            No records found
                        </template>
                        <!-- <Column field="serial" header="#"></Column> -->
                        <Column field="id" header="ID"></Column>
                        <Column header="Product">
                            <template #body="{data}">
                                <div>{{ data.product ? data.product.name : 'GPS Tracking' }}</div>
                                <div v-if="data.items && data.items.length" class="sale-lines">
                                    <div v-for="item in data.items" :key="item.id">{{ item.name }}: {{ item.quantity }} × {{ item.unit_price }}<span v-if="item.charge_type === 'recurring'"> × {{ item.periods }}</span></div>
                                    <b v-if="data.total_value">Total: {{ data.total_value }}</b>
                                </div>
                            </template>
                        </Column>
                        <Column field="company_name" header="Company"></Column>
                        <Column field="company_address" header="Company Address"></Column>
                        <Column field="client_name" header="Client"></Column>
                        <Column field="client_phone" header="Client Phone"></Column>
                        <Column field="power_source_type" header="Power Sourch Type"></Column>
                        <Column field="sale_type" header="Sales Type"></Column>
                        <Column field="salesBy" header="Sales By">
                            <template #body="{data}">
                                <div v-html="data.sales_by.name"></div>
                            </template>
                        </Column>
                        <Column field="number_of_ships" header="Number of Ships">
                            <template #body="{data}">
                                <div>
                                    {{data.installation_requistions.length}} / {{data.number_of_ships}}
                                </div>
                            </template>
                        </Column>
                        <Column field="installation_charge_per_ship" header="Installation Charge / Ship"></Column>
                        <Column field="solar_panel_price_per_ship" header="Solar Panel Price / Ship"></Column>
                        <Column field="monthly_subscription_fee_per_ship" header="Monthly Subs. Fee / Ship"></Column>
                        <Column field="device_price_per_ship" header="Device Price / Ship"></Column>
                        <Column field="warantry_days" header="Warantry Days"></Column>
                        <Column field="source_of_sale" header="Source of Sale"></Column>
                        <Column field="status" header="Status"></Column>
                        <Column field="" header="">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" v-if="jsonDecode(data.approval_status)">
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">1st Approval
                                                ({{jsonDecode(data.approval_status)['first_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['first_approval']}}</ion-col>
                                    </ion-row>
                                    <ion-row v-if="data.status == 'Pending' && jsonDecode(data.approval_status)['first_approval'] == 'No' && user!=null && user.id == 32">
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Approve')" size="small" color="success" fill="outline">Approve</ion-button>
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Cancel')" size="small" color="danger" fill="outline">Cancel</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        <Column field="" header="">
                            <template #body="{data}">
                                <ion-grid class="ion-no-padding" v-if="jsonDecode(data.approval_status)">
                                    <ion-row>
                                        <ion-col class="ion-text-left " size="10">
                                            <strong style="font-weight: 600;">Final Approval
                                                ({{jsonDecode(data.approval_status)['final_approver']['name']}})</strong>
                                        </ion-col>
                                        <ion-col class="ion-text-right " size="2">
                                            {{jsonDecode(data.approval_status)['final_approval']}}</ion-col>
                                    </ion-row>
                                    <ion-row v-if="data.status == 'Pending' && jsonDecode(data.approval_status)['final_approval'] == 'No' && user!=null && user.id == 3">
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Approve',jsonDecode(data.approval_status)['first_approval']=='No' ? true:false)" size="small" color="success" fill="outline">Approve</ion-button>
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                                @click="ApprovedOrCancelSale(data.id,'Cancel')" size="small" color="danger" fill="outline">Cancel</ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </template>
                        </Column>
                        <Column field="number_of_ships" header="Action">
                            <template #body="{data}">
                                <div v-if="['Pending','Cancel'].includes(data.status) == false">
                                    <ion-button v-if="data.installation_requistions.length < data.number_of_ships"
                                        @click="createRequisiton(data.id,data.has_companies)" size="small">Create
                                        Requisition</ion-button>
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>

            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import {
        IonButtons,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonTitle,
        IonToolbar,
        IonButton,
        IonGrid,
        IonRow,
        IonCol,
        IonSegment,
        IonSegmentButton,
        IonLabel,
        alertController,
    } from '@ionic/vue';
    import {
        defineComponent
    } from 'vue';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';

    export default defineComponent({
        name: 'All Sales',
        components: {
            IonButtons,
            IonButton,
            IonContent,
            IonHeader,
            IonMenuButton,
            IonPage,
            IonTitle,
            IonToolbar,
            DataTable,
            Column,
            IonGrid,
            IonRow,
            IonCol,
            IonSegment,
            IonSegmentButton,
            IonLabel,
        },
        data() {
            return {
                requisitions: [],
                sales: [],
                pendingSales: [],
                pendingInstallations: [],
                segment: this.$route.params.segment?this.$route.params.segment:'PendingInstallation',
                user:null,
                allSale: false,
                pendingInstallation: false,
                pendingSale: false,
                loading: false,
                perPage: 30,
                total: 0,
                pendingPerPage: 30,
                pendingTotal: 0,
                pendingInsPerPage: 30,
                pendingInsTotal: 0,
            }
        },
        mounted() {
            if(this.$route.params.segment && this.$route.params.segment == 'AllSale'){
                this.allSale = true;
                this.loadData(0);
            }
            else if(this.$route.params.segment && this.$route.params.segment == 'PendingSale'){
                this.pendingSale = true;
                this.loadPendingSales(0);
            }
            else{
                this.pendingInstallation = true;
                this.loadPendingInstallationSales(0);
            }
        },
        methods: {
            createRequisiton(saleId, hasCompanies) {
                if (!hasCompanies) {
                    this.$router.push('/client-register/' + saleId);
                } else {
                    this.$router.push('/existing-client/' + saleId);
                }
            },
            jsonDecode(e) {
                if (e) {
                    const data = JSON.parse(e);
                    return data;
                } else {
                    return false;
                }
            },

            async loadData(page) {
                const data = {
                    'page': page + 1,
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                    'saleId': this.$route.params.saleId,
                };
                this.loading = true;
                this.$http.post('allSales', data).then(response => {
                    // const rows=[];
                    if(response.data.user.id == 3 || response.data.user.id == 12){
                        this.user = response.data.user;
                    }
                    const sale = response.data.sale;
                    this.perPage = sale.per_page;
                    this.total = sale.total;
                    this.sales = sale.data;
                    // let serial= (page * this.perPage) + 1;
                    // const reqs=[];
                    // for(const req of response.data.data){
                    //     reqs.push({
                    //         serial: serial++,
                    //         id:req.id,
                    //         shipName:req.ship_name +" "+ req.m_number +" "+ req.ship_type.ship_type_name,
                    //         company:req.client.company.company_name,
                    //         client:req.client.client_name  + ' (' + req.client.mobile  + ')',
                    //         contact: req.contact_person  + ' (' + req.contact_person_mobile + ')',
                    //         port:req.port.port_name,
                    //         installationDate:req.installation_date,
                    //         status: req.requisition_status,
                    //     });
                    // }
                    // this.requisitions=reqs;
                    // console.log(this.requisitions);
                    this.loading = false;
                });

            },
            async loadPendingSales(page) {
                const data = {
                    'page': page + 1,
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                    'saleId': this.$route.params.saleId,
                };
                this.loading = true;
                this.$http.post('pendingSales', data).then(response => {
                    console.log(response);
                    if(response.data.user.id == 3 || response.data.user.id == 12){
                        this.user = response.data.user;
                    }
                    const sale = response.data.sale;
                    this.pendingPerPage = sale.per_page;
                    this.pendingTotal = sale.total;
                    this.pendingSales = sale.data;
                    this.loading = false;
                });

            },
            async loadPendingInstallationSales(page) {
                
                const data = {
                    'page': page + 1,
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                };
                this.loading = true;
                this.$http.post('pendingInstallationSales', data).then(response => {
                    // console.log(response);
                    
                    const sale = response.data;
                    this.pendingInsPerPage = sale.per_page;
                    this.pendingInsTotal = sale.total;
                    this.pendingInstallations = sale.data;
                    this.loading = false;
                });

            },
            ApprovedOrCancelSale(id,status,firstApproval = false){
                let confirmMsg = "Are you sure to "+status+" this sale?";
                if(status != 'Cancel' && firstApproval){
                    confirmMsg = "The first approval is not yet done. Are you sure to "+status+" this sale?";
                }
                if(confirm(confirmMsg)){
                    const data = {
                        'username': window.localStorage.username,
                        'password': window.localStorage.password,
                        'id':id,
                        'status':status=='Approve'? 'Approved' : 'Cancel',
                    };
                    this.$http.post('approvedOrCancelSale', data).then(response => {
                        if(response.data.status){
                            this.presentAlert(response.data.message);
                            this.allSale = false;
                            this.pendingSale = false;
                            this.pendingInstallation = false;
                            if(this.$route.params.segment && this.$route.params.segment == 'AllSale'){
                                    this.allSale = true;
                                    this.loadData(0);
                                }
                                else if(this.$route.params.segment && this.$route.params.segment == 'PendingSale'){
                                    console.log('PendingSale');
                                    this.pendingSale = true;
                                    this.loadPendingSales(0);
                                }
                                else{
                                    this.pendingInstallation = true;
                                    this.loadPendingInstallationSales(0);
                                }
                        }
                    });
                }
            },
            segmentChanged(event) {
                this.pendingInstallation = false;
                this.pendingSale = false;
                this.loading = false;
                this.segment = event.target.value;
                this.allSale = false;
                this.pendingSale = false;
                this.pendingInstallation = false;
                if (event.target.value == 'AllSale') {
                    this.loadData(0);
                    this.allSale = true;
                    return this.$router.push(`/all-sales/${event.target.value}`);
                } else if (event.target.value == 'PendingSale') {
                    this.loadPendingSales(0);
                    this.pendingSale = true;
                    return this.$router.push(`/all-sales/${event.target.value}`);
                } else {
                    this.loadPendingInstallationSales(0);
                    this.pendingInstallation = true;
                    return this.$router.push(`/all-sales/${event.target.value}`);
                }
            },
            onPage(event) {
                this.loadData(event.page);
            },
            pendingSaleOnPage(event) {
                this.loadPendingSales(event.page);
            },
            pendingInsSaleOnPage(event) {
                this.loadPendingInstallationSales(event.page);
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },
        },

    });
</script>

<style scoped>
.sale-lines { font-size: 0.78rem; color: #475569; margin-top: 2px; }
    .dataRow:nth-child(even) {
        background-color: #f2f2f2 !important;
    }
</style>